"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const LogMessageDataType_1 = require("@/common/logs/LogMessageDataType");
const Card_vue_1 = __importDefault(require("@/client/components/card/Card.vue"));
const GlobalEvent_vue_1 = __importDefault(require("@/client/components/turmoil/GlobalEvent.vue"));
const AppButton_vue_1 = __importDefault(require("@/client/components/common/AppButton.vue"));
const Colony_vue_1 = __importDefault(require("@/client/components/colonies/Colony.vue"));
exports.default = (0, vue_1.defineComponent)({
    name: 'log-panel',
    props: {
        message: {
            type: Object,
            required: true,
        },
        players: {
            type: Array,
            required: true,
        },
    },
    components: {
        AppButton: AppButton_vue_1.default,
        Card: Card_vue_1.default,
        Colony: Colony_vue_1.default,
        GlobalEvent: GlobalEvent_vue_1.default,
    },
    computed: {
        show() {
            return this.cards.length + this.globalEvents.length + this.colonies.length > 0;
        },
        cards() {
            return this.message.data
                .filter((datum) => datum.type === LogMessageDataType_1.LogMessageDataType.CARD || datum.type === LogMessageDataType_1.LogMessageDataType.CARDS)
                .flatMap((datum) => datum.type === LogMessageDataType_1.LogMessageDataType.CARD ? [datum.value] : datum.value);
        },
        globalEvents() {
            return this.message.data.filter((datum) => datum.type === LogMessageDataType_1.LogMessageDataType.GLOBAL_EVENT).map((datum) => datum.value);
        },
        colonies() {
            return this.message.data.filter((datum) => datum.type === LogMessageDataType_1.LogMessageDataType.COLONY).map((datum) => datum.value);
        },
    },
    methods: {
        hideMe() {
            this.$emit('hide');
        },
        getColony(name) {
            return {
                colonies: [],
                isActive: false,
                name: name,
                trackPosition: 0,
                visitor: undefined,
            };
        },
        isSelfReplicatingRobotsCard(cardName) {
            for (const player of this.players) {
                if (player.selfReplicatingRobotsCards.some((card) => card.name === cardName)) {
                    return true;
                }
            }
            return false;
        },
        getResourcesOnCard(cardName) {
            for (const player of this.players) {
                const playedCard = player.tableau.find((card) => card.name === cardName);
                if (playedCard !== undefined) {
                    return playedCard.resources;
                }
                const srrCard = player.selfReplicatingRobotsCards.find((card) => card.name === cardName);
                if (srrCard !== undefined) {
                    return srrCard.resources;
                }
            }
            return undefined;
        },
    },
});
